<template>
  <div class="form-group last">
    <fieldset :disabled="formData.disableExchanges">
      <h5>Choose Exchange(IX)*</h5>
      <p
        v-if="formData.isloading"
      >
        loading ...
      </p>
      <p
        v-if="formData.noExchanges"
      >
        No common internet exchanges found!
      </p>
      <div
        v-else-if="!formData.isloading"
        class="custom-control"
      >
        <label
          v-for="ix in networkDetails.internetExchanges"
          :key="ix.name"
          :for="ix.name"
          class="custom-control-label"
        ><span class="checkmark" /><input
          :id="ix.name"
          v-model="updateExchanges"
          type="checkbox"
          class="custom-control-input"
          :value="ix.name"
        >
          <div>{{ ix.name }}</div>
        </label>
      </div>
    </fieldset>
  </div>
</template>


<script>
import VueRecaptcha from "vue-recaptcha";

import {
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";

export default {
  name: "ExchangeFieldset",
  components: {
  },
  computed: {
    formData() {
      return this.$store.state.formData;
    },
    networkDetails() {
      return this.$store.state.networkDetails;
    },
    updateExchanges: {
      get() {
        return this.$store.state.formData.exchangeOptions;
      },
      set(value) {
        this.$store.commit("setFormDataExchangeOptions", value);
      }
    }
  }
};
</script>

<style lang="scss">
@import "/less/anx-button.less";
@import "/less/anx-checkbox.less";
@import "/less/anx-peering-form.less";
</style>
